import { useContext } from 'react';
import { AuthContext, type AuthContextValue } from './authContext';

/** Acceso al estado/acciones de sesión. Lanza si se usa fuera del provider. */
export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (ctx === null) {
    throw new Error('useAuth debe usarse dentro de <AuthProvider>');
  }
  return ctx;
}
